<template>
    <div class="twoBannerHome wow fadeInAnimated fadeIn">
        <div class="title">
            <img :src="haojobLogo" alt="" class="haojobImg" @click="goHome" style="cursor:pointer;">
            <span class="selectCity">全国站></span>
            <ul class="tabItem">
                <li @click="goHome">首页</li>
                <li @click="$router.push('/investment')">招商加盟</li>
                <li @mouseenter="appDownload"  @mouseleave="leaveDownload" :class="appTrueActive?'active':''">APP下载</li>
                <li @click="$router.push('/relationPages')">联系我们</li>
                <li style="width: 100px;height: 35px;background: #FFFFFF;border: 1px solid #1D5EEA;line-height:35px;text-align: center;margin-top:22.5px;padding:0;"><a style="color:#1D5EEA;text-decoration: none;" href="http://consoletwo.lielanghr.com/#/login">劳务登录</a></li>
            </ul>
        </div>
        <downloadApp v-if="appTrueActive"></downloadApp>
        <div class="centerFloat">
            <div class="header">
                <img :src="banner" class="banner" alt="" @click="enterWindowClick">
            </div>
            <div class="enterEd">
                <p class="enterEdTitle">已入驻地区</p>
                <ul class="contCity">
                    <li v-for="(ite,inde) in enterCityData" :key="inde"> 
                        <span class="cityTile" @click="gocityDetail(ite.provincesName)">{{ite.street}}</span>
                        <span class="cityCount">
                            <span v-for="(item,index) in ite.objd" :key="index" class="cityCountList" @click="gocityDetail(ite.provincesName+' '+item.provincesName)">
                                <span class="countryName">{{item.provincesName}}</span>
                                <span class="countGray">· {{item.citySum}}个街道</span>
                            </span>
                        </span>
                    </li>
                </ul>
            </div>
            <div class="enterEd" style="margin-top:45px;">
                <p class="enterEdTitle">可入驻地区</p>
                <ul class="contCity">
                    <li v-for="(ite,inde) in provinceData" :key="inde"> 
                        <span class="cityTile">{{ite.name}}</span>
                        <span class="cityCount">
                            <span v-for="(item,index) in ite.districts" :key="index"  @mouseover="onMousteIn(inde,index)" @mouseleave="onMousteOut()" :class="seen&&index==current&&inde==currentInde?'trueCity trueCityAcity':'trueCity'">
                                <span class="countryName">{{item.name}}</span>
                                <span class="enterClass" @click="enterWindowClick" v-show="seen&&index==current&&inde==currentInde">入驻</span>
                            </span>
                        </span>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 入驻弹窗 -->
        <div class="enterWindow" v-if="maskTrue">
            <div class="maskBack"></div>
            <div class="writeCont">
                <div class="writeTitle">填写资料，立即入驻</div>
                <div class="writeContBorder">
                    <div class="selectAndInput">
                        <label for="" class="labelName">我的身份</label>
                        <div class="boxTab">
                            <span v-for="(items,index) in tabs" :key="index" :class="curentIdent==index? 'activeIdentity identity':'identity'" @click="tabIdentity(index)">{{items}}</span>
                        </div>
                    </div>
                    <div class="selectAndInput phoneInput">
                        <label for="" class="labelName">我的姓名</label>
                        <input type="text" minlength="1" maxlength="6" placeholder="请输入" v-model="form.name">
                    </div>
                    <div class="selectAndInput phoneInput">
                        <label for="" class="labelName">联系方式</label>
                        <input  :class="phoneNumberStyle==true ? 'activeColor':''" type="number" placeholder="请输入手机号" oninput="if(value.length > 11)value = value.slice(0, 11)" v-model="form.phone">
                    </div>
                    <div class="wantSay">
                        <label for="" class="labelName">想说的话</label>
                        <textarea name="" v-model="form.applyReason" id="" cols="30" maxlength="200" placeholder="请填写您想和我们说的话" rows="10"></textarea>
                        <span>{{form.applyReason.length}}/200</span>
                    </div>
                    <div class="submit">
                        <div @click="submit" :disabled="!loading" :class="canSubmit==true ? 'btn-active':''">提  交</div>
                    </div>  
                </div>
                <span class="closeImg" @click="closeMask">
                    <img :src="closeImg" alt="">
                </span>
            </div>
        </div>
        <div class="taskShade" v-if="centerTaskTrue">
            <div class="centerTask">
                <p>提示</p>
                <span>{{testMessage}}</span>
            </div>
        </div>
        <footerPages :backColor="'#3A3D53'" :borderBottom="'1px solid #626475'"></footerPages>
    </div>
</template>

<script>
import {WOW} from 'wowjs'
import banner from '@/assets/banner@2x.png'
import haojobLogo from '@/assets/haoojoblogo.svg'
import api from '@/api'
import closeImg from '@/assets/close@3x.png'

export default {
    data(){
        return {
            appTrueActive:false,
            closeImg,
            haojobLogo,
            banner,
            testMessage:'客服将在1～3个工作日内联系您，请您保持电话畅通',
            centerTaskTrue:false,
            curentIdent:0,
            maskTrue:false,
            typeName:'请选择',
            loading:true,
            tabs: ['劳务公司','招聘门店','招聘专员'],
            form:{
                type:'',
                name:'',
                phone:'',
                applyReason:'',
                sourceType:2,
            },
            currentInde:0,
            current: 0,//复制成功提示显示或者隐藏 
            seen: false, //显示和隐藏
            enterCityData:[],
            provinceData:[]
        }
    },
    computed:{
        // 用于校验手机号码格式是否正确
        phoneNumberStyle(){
            let reg = /^1[3456789]\d{9}$/
            if(!reg.test(this.form.phone)){
                return false
            }
            return true
        },
        canSubmit(){
            console.log(11,this.form.type,this.form.name,this.phoneNumberStyle)
            if(this.phoneNumberStyle && this.form.name){
                return true
            }else{
                return false
            }
        },
    },
    methods:{
        appDownload(){//移入App下载
            this.appTrueActive=true
        },
        leaveDownload(){
            this.appTrueActive=false
        },
        goHome(){
            this.$router.push('/')
        },
        gocityDetail(data){
            this.$router.push(`/inTheCity/`+encodeURI(data))
        },
        onMousteIn(inde,index) {
            console.log(index)
            this.seen = true; //鼠标移入显示
            this.currentInde = inde
            this.current = index;
        },
        onMousteOut() {
            this.seen = false; //鼠标移出隐藏
            this.current = null;
            this.currentInde = null;
        },
        tabIdentity(index){
            this.curentIdent=index
        },
        enterWindowClick(){
            this.maskTrue=true
        },
        closeMask(){
            this.maskTrue=false
        },
        async submit(){
            let that = this
            if(this.curentIdent==0){
                this.form.type=3
            }else if(this.curentIdent==1){
                this.form.type=1
            }else if(this.curentIdent==2){
                this.form.type=0
            }
            this.loading=true
            if(this.canSubmit&&this.loading){
                this.loading=false
                let res = await api.roleApplySave(this.form)
                if(res.code==200){
                    this.maskTrue=false
                    that.centerTaskTrue=true
                    setTimeout(function(){
                        that.centerTaskTrue=false
                    },3000)
                }else{
                    this.maskTrue=false
                    that.centerTaskTrue=true
                    setTimeout(function(){
                        that.centerTaskTrue=false
                    },3000)
                    this.testMessage=res.message
                }
            }
        },
        goLabourDetail(data){//跳转劳务公司主页
            this.$router.push(`/labourDetail/`+data.id)
        },
        async getCityList(){
            let res = await api.cityList()
            let obj = res
            for(let i in obj){
                obj[i].provincesName
                this.getStreetList(obj[i].provincesName)
            }
        },
        async getStreetList(street){
            let query={
                provinces:street,
            }
            let res = await api.cityList(query)
            let obj = res //城市下面的所有区或者街道数据
            let news={
                provincesName:street,
                street:street.split(' ')[1],
                objd:obj
            }
            this.enterCityData = this.enterCityData.concat(news)
        },
        addressCity (sum) {
            if(sum){
                let city = sum.split(" ")[1]
                if(city==="市辖区" || city==="县"){
                    return sum.split(" ")[0]
                }
                return city
            }else {
                return ''
            }
        },
        cityChange(e) {
            //选择城市
            let type = "province";
            this.initCity(e, type);
        },
        async initCity(name, type) {
            // //省份数据
            let query = {
                key: "8418023b22068771f270aaddc3628448", //高德key
                keywords: name,
                subdistrict: 2,
            };
            let industryDataDww = await api.getCountryData(query);
            if (type == "province") {
                this.provinceData = industryDataDww.districts[0].districts;
                console.log('provinceData',this.provinceData)
            }
        },
    },
    mounted () {
        let wow = new WOW({
                boxClass: 'wow',
                animateClass: 'animated',
                offset: 0,
                mobile: true
        })
        wow.init();
    },
    created(){
        this.getCityList()
        this.cityChange()
    }
}
</script>
<style src='@/pages/components/publicStyle/animated.css' scoped></style>
<style scoped lang="less">
    .haojobImg{
        float: left;
        margin-right: 20px;
    }
    .selectCity{
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
        margin-top:20px;
        cursor: pointer;
        float: left;
    }
    .taskShade{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        justify-content: center;
        align-items: center;
        display: flex;
        z-index: 1000;
    }
    .centerTask{
        width: 450px;
        background: rgba(0,0,0,.6);
        border-radius: 10px;
        display: flex;
        align-content: center;
        flex-wrap: wrap;
        justify-content: space-around;
        padding: 30px;
    }
    .centerTask>p{
        width: 100%;
        text-align: center;
        font-size: 30px;
        line-height: 46px;
        color: #fff;
        margin-top: 15px;
        margin-bottom: 19px;
    }
    .centerTask>span{
        color: #fff;
        font-size: 26px;
        line-height: 40px;
        text-align: center;
        display: block;
    }
    .enterWindow{
        width: 100%;
        height: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 10000;
        justify-content: center;
        align-items: center;
        display: flex;
        .maskBack{
            background: rgba(0, 0, 0, 0.4);
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 99;    
        }
        .writeCont{
            width: 700px;
            max-width: 700px;
            background: #fff;
            position: relative;
            overflow-y: auto;
            z-index: 100;
            padding: 60px 80px;
            box-sizing: border-box;
            position: fixed;
            top: 60px;
            bottom: 60px;
            .writeTitle{
                width: 100%;
                font-size: 30px;
                font-weight: 500;
                color: #222222;
                line-height: 76px;
            }
            .writeContBorder{
                width: 100%;
                height: auto;
                overflow: hidden;
                margin-top: 30px;
                .selectAndInput{
                    width: 100%;
                    height: 50px;
                    line-height: 50px;
                    margin-top: 20px;
                    .boxTab{
                        width: 450px;
                        height: 50px;
                        line-height: 50px;
                        overflow: hidden;
                        float: right;
                        .identity{
                            width: 33.3%;
                            cursor: pointer;
                            height: 50px;
                            text-align: center;
                            float: left;
                            border: 1px solid #CCCCCC;
                            box-sizing: border-box;
                        }
                        .identity:nth-child(2),.identity:nth-child(1){
                            border-right: 0;
                        }
                        .activeIdentity{
                            background: #1D5EEA;
                            color: #fff;
                        }
                    }
                    .labelName{
                        font-size: 18px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 50px;
                        float: left;
                    }
                    input{
                        width: 450px;
                        height: 50px;
                        float: right;
                        font-size: 18px;
                        color: #333;
                        padding: 0 19px;
                        box-sizing: border-box;
                        overflow: hidden;
                        border: 1px solid #ccc;
                        outline: none;
                    }
                    input::placeholder{
                        color: #CCCCCC;
                    }
                }
                .wantSay{
                    margin-top: 20px;
                    overflow: hidden;
                    position: relative;
                    span{   
                        font-size: 18px;
                        font-weight: 500;
                        color: #CCCCCC;
                        position: absolute;
                        bottom: 15px;
                        right: 15px;
                    }
                    .labelName{
                        font-size: 18px;
                        font-weight: 400;
                        color: #333333;
                        line-height: 50px;
                        float: left;
                    }
                    textarea{
                        float: right;
                        width: 450px;
                        font-size: 18px;
                        height: 200px;
                        border: 1px solid #ccc;
                        padding: 20px;
                        box-sizing: border-box;
                        line-height: 30px;
                        resize:none;
                        outline: none;
                    }
                }
                .submit{
                    div{
                        width: 450px;
                        height: 56px;
                        background: #1D5EEA;
                        font-size: 20px;
                        font-weight: 500;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 56px;
                        float: right;
                        margin-top: 32px;
                        cursor: pointer;
                        opacity: 0.3;
                    }
                    .btn-active{
                        opacity: 1;
                    }
                }
            }
            .closeImg{
                width: 40px;
                height: 40px;
                display: block;
                position: absolute;
                right: 0;
                top: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                img{
                    width: 15px;
                    height: 15px;
                    display: block;
                }
            }
        }
        .successWindow{
            height: 351px;
        }
    }
    .centerFloat{
        width: 100%;
        height: auto;
        overflow: hidden;
        background: #F3F5F8;
        box-sizing: border-box;
        .header{
            width: 100%;
            .banner{
                width: 100%;
                cursor: pointer;
                height: 80px;
            }
        }
        .enterEd{
            width: 1200px;
            height: auto;
            box-sizing: border-box;
            overflow: hidden;
            margin: 0 auto;
            margin-bottom: 20px;
            .enterEdTitle{
                font-size: 24px;
                
                font-weight: 400;
                color: #333333;
                margin-top: 38px;
            }
            .contCity{
                width: 100%;
                height: auto;
                background: #fff;
                margin-top: 20px;
                li{
                    width: 100%;
                    height: auto;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    .cityTile{
                        width: 127px;
                        height: 40px;
                        line-height: 40px;
                        cursor: pointer;
                        display: block;
                        // margin: 33px 0;
                        float: left;
                        padding: 0 15px;
                        box-sizing: border-box;
                        white-space: nowrap; text-overflow: ellipsis; overflow: hidden;
                        text-align: center;
                        line-height: auto;
                        font-size: 18px;
                        color: #333;
                    }
                    .cityCount{
                        width: 1072px;
                        height: auto;
                        overflow: hidden;
                        display: block;
                        float: left;
                        box-sizing: border-box;
                        border-left: 1px solid #ccc;
                        margin:20px 0;
                        padding-left: 40px;
                        .cityCountList{
                            width: auto;
                            float: left;
                            cursor: pointer;
                            line-height: 34px;
                            // margin: 5px 0; 
                            margin-right: 40px;
                            .countryName{
                                float: left;
                                font-size: 14px;
                                font-weight: 400;
                                color: #333333;
                                display: block;
                                margin-right: 5px;
                            }
                            .countGray{
                                float: left;
                                display: block;
                                font-size: 14px;
                                font-weight: 400;
                                color: #999;
                            }
                        }
                        .trueCity{
                            padding: 11px 15px;
                            box-sizing: border-box;
                            display: flex;
                            float: left;
                            flex-direction: column;
                            text-align: center;
                            position: relative;
                            height: 70px;
                            font-size: 14px;
                            min-width: 90px;align-items: center;
                            .countryName{
                                text-align: center;
                            }
                            .enterClass{
                                width: 60px;
                                line-height: 26px;
                                text-align: center;
                                background: #1D5EEA;
                                color: #fff;
                                cursor: pointer;
                                margin: 0 auto;
                                position: absolute;
                                bottom: 10px;
                            }
                        }
                        .trueCityAcity{
                            background: #F3F5F8;
                        }
                    }
                }
            }
        }
    }
    
</style>